import React from "react";
import Button from "../../sub-component/Button";
import { useSelector } from "react-redux";
import { ReactComponent as SettingsIcon } from "../../../assets/icons/basic/settings(2).svg";
import { useMediaQuery } from "@mui/material";
import { fontFamily, fontSize, height, width } from "@mui/system";

const IntegrationCard = ({
  name,
  logo,
  status,
  connected,
  onClick,
  processing,
  isConnected,
  appToken
}) => {
  const isOnMobileScreen = useMediaQuery("(max-width: 767px)");

  return (
    <div
      className=" d-flex flex-row align-items-center justify-content-between "
      style={{
        borderRadius: "12px",
        background: "#F6F5F8",
        padding: "12px",
      }}
      onClick={() => onClick(name)}
    >
      <div className="d-flex" style={{ gap: "2px" }}>
        <img
          src="https://www.workable.com/static/favicon-64x64.png"
          alt={name}
          // className="rounded"
          // style={{ width: "50px", height: "50px" }}
        />
        <div
          className="d-flex ms-3"
          style={{ flexDirection: "column", justifyContent: "center" }}
        >
          <h5 className="mb-1 subtitle-2">{name}</h5>
          <span
            className="text-success body-3"
            style={{
              background: "#E8F5E9",
              borderRadius: "24px",
              padding: "4px 12px 4px 12px",
              width: "46px",
              fontSize: "12px",
            }}
          >
            {status}
          </span>
        </div>
      </div>
      {isConnected ? (
        isOnMobileScreen ? (
          <div className="d-flex justify-content-center align-items-center" style={{width:'40px' ,height:'40px',borderRadius:'50px',background:'black'}}>
            <SettingsIcon style={{height:'20px',width:'20px'}}/>
          </div>
        ) : (
          <Button
            btn="ragular-btn"
            varrient="secondary-btn"
            title="Settings"
            style={{
              height: "40px",
              marginTop: "0px",
              width: "100px",
              fontFamily:'Urbanist',
              fontSize:'14px'

            }}
            processing={processing}
            onClick={onClick}
          />
        )
      ) : (
        <Button
          themeRectangleButton
          processing={processing}
          title="Connect"
          style={{
            height: "40px",
            marginTop: "0px",
            width: "100px",
            fontFamily:'Urbanist',
            fontSize:'14px'
          }}
          onClick={onClick}
        />
      )}
    </div>
  );
};

export default IntegrationCard;
